import {remCalc} from '_themeUtils'

const chips = {
    Chips: {
        baseStyle: () => ({
            wrapper: {
                width: 'fit-content',
                minH: remCalc(34),
                letterSpacing: remCalc(1),
                textStyle: 'paragraphSm',
                fontWeight: 400,
                color: 'color.text.button.primary.default',
                bg: 'color.background.button.primary.default',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 'spacing.1',
                p: 'spacing.1',
                pl: 'spacing.3',
                whiteSpace: 'nowrap',
                // _hover: {
                //     color: 'color.text.button.primary.hover',
                //     bg: 'color.background.button.primary.hover',
                // },
            },
        }),
    },
}

export default chips
